import { render, staticRenderFns } from "./PaginationMobile.vue?vue&type=template&id=1ecdeb47&"
import script from "./PaginationMobile.vue?vue&type=script&lang=js&"
export * from "./PaginationMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports